// import {Transform, RAF} from 'f.component.util';
import 'pixi.js';
import './zan.scss';
import ZanTpl from './zan.ejs';

class DianZan{
    constructor({message, dianzan_config = {}, containerClass}) {
        this.message = message;
        this.config = dianzan_config;
        this.containerClass = containerClass;
        this.init();
    }

    init() {
        this.state = true; //canvas状态
        this.timer = null;
        this.heartsContainer = []; // 管理容器

        this.initCallback = this.config.initCallback || function() {};
        this.speed = this.config.speed || .008;
        this.t = this.config.t || 0;
        this.originX = this.config.originX || 300;
        this.originY = this.config.originY || 500;
        this.heartX = this.config.heartX || 50;
        this.heartY = this.config.heartY || 20;
        this.praiseType = this.config.praiseType || '2';

        this.initDom();
        this.initCanvas(this.config); // 初始化canvas
        this.initEvent();
        this.loadResources(this.setup); //加载资源
        this.initCustomEvent();
    }

    initDom() {
        this.boxDom = $(ZanTpl());
        this.container = this.boxDom.find('#zan-canvas')[0];
        this.btnDom = this.boxDom.find('.btn');
        $(this.containerClass).append(this.boxDom);
    }
    
    initCanvas(options) {
        var DPR = 1;
        var WIDTH = parseInt(document.documentElement.clientWidth / DPR);
        var HEIGHT = parseInt(document.documentElement.clientHeight / DPR);

        this.scale = parseFloat(WIDTH / 750);
        this.width = (options.width || 400) * this.scale;
        this.height = (options.height || 600) * this.scale;

        this.stage = new PIXI.Container();
        this.renderer = PIXI.autoDetectRenderer(
            this.width,
            this.height, {
                antialias: true,
                view: this.container,
                transparent: true
            }
        );
    }

    initEvent() {
        this.btnDom.on('click', this.zan.bind(this))
        this.btnDom.one('click', this.sendToMessageCenter.bind(this))
    }

    initCustomEvent() {
        this.receiveFromMessageCenter();
    }

    receiveFromMessageCenter() {
        this.message.on('praise:zan', 201, this.zan.bind(this));
    }

    sendToMessageCenter() {
        this.message.send('praise', 101);
    }

    loadResources(callback) {
        var _this = this;

        var data = {};
        if (this.praiseType === '2') {
            data = require('./heart.json');
        } else if (this.praiseType === '3') {
            data = require('./candle.json');
        }

        const baseTexture = new PIXI.BaseTexture.from(data.meta.image, null, 1);
        const spritesheet = new PIXI.Spritesheet(baseTexture, data);
        spritesheet.parse(textures => {
           // finished preparing spritesheet textures
           callback.bind(_this)()
        });
    }

    setup() {
        this.updateCanvas();
        this.initCallback();
    }

    genCoord() {
        var _originX = this.originX,
            _originY = this.originY,
            _heartX = this.heartX,
            _heartY = this.heartY;

        var _l = Math.random() > 0.5 ? 1 : -1;

        var start = { x: _originX, y: _originY };
        var c1 = { x: _originX + _l * random(_heartX, 2 * _heartX), y: (_originY - _heartY) * random(5, 7) / 10 };
        var c2 = { x: _originX - _l * random(_heartX, 2 * _heartX), y: (_originY - _heartY) * random(2, 4) / 10 };
        var end = { x: _originX + random(-_heartX, _heartX), y: _heartY };
        // console.log([start, c1, c2, end])
        return [start, c1, c2, end]
    }

    updateCanvas() {
        var _position = null;
        if (!this.state) {
            return;
        }

        for (var i = 0; i < this.heartsContainer.length; i++) {
            if (this.heartsContainer[i].t > 1) {

                this.heartsContainer[i].destroy();
                this.heartsContainer.splice(i, 1);
                i--;
            } else {

                _position = this.heartsContainer[i].bezierCurveTo(this.heartsContainer[i].t);
                this.heartsContainer[i].position.x = _position[0] * this.scale;
                this.heartsContainer[i].position.y = _position[1] * this.scale;
                this.heartsContainer[i].t += this.speed;
                this.heartsContainer[i].alpha = 1 - this.heartsContainer[i].t;
            }
        }

        this.renderer.render(this.stage);

        requestAnimationFrame(this.updateCanvas.bind(this));
    }

    initHeart(name, data) {
        var _heart = new PIXI.Sprite(new PIXI.Texture.fromFrame(name + '.png'));
        _heart.t = 0;
        _heart.bezierCurveTo = this.bezierCurveTo(data[0], data[1], data[2], data[3]);
        _heart.anchor.set(0.5);
        _heart.scale.set(this.scale);
        // 放置在画面中间靠下的位置
        _heart.position.set(data[0].x, data[0].y);

        this.heartsContainer.push(_heart);
        this.stage.addChild(_heart);
    }

    bezierCurveTo(s, c1, c2, e, t) {
        var cx1 = 3 * (c1.x - s.x);
        var bx1 = 3 * (c2.x - c1.x) - cx1;
        var ax1 = e.x - s.x - cx1 - bx1;

        var cy1 = 3 * (c1.y - s.y);
        var by1 = 3 * (c2.y - c1.y) - cy1;
        var ay1 = e.y - s.y - cy1 - by1;

        return function(t) {

            var _x = ax1 * (t * t * t) + bx1 * (t * t) + cx1 * t + s.x;
            var _y = ay1 * (t * t * t) + by1 * (t * t) + cy1 * t + s.y;

            return [_x, _y];
        }
    }

    start(time) {
        var _this = this;
        clearInterval(this.timer);
        this.timer = interval(function() {
            _this.initHeart('heart' + random(0, 5), _this.genCoord())
        }, time)
    }

    stop() {
        clearInterval(this.timer);
    }

    zan(fn) {
        this.initHeart('heart' + random(0, 5), this.genCoord());
        fn && (typeof fn == 'function') && fn();
        return false;
    }

    show() {
        this.btnDom.animate({opacity: '1'});
        this.boxDom.show();
    }

    hide() {
        this.btnDom.animate({opacity: '0'});
        this.boxDom.hide();
    }
}

function random(n, m) {
    return Math.floor(Math.random() * (m - n + 1) + n);
}

function interval(func, wait) {
    var interv = function() {
        func.call(null);
        setTimeout(interv, wait);
    };
    setTimeout(interv, wait);
}

export default DianZan;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.dianzan.pc/app/lib/zan.js